import React from "react";
import lockIcon from "../../icons/pass-badge-lock.svg";
import PassPromoDateCard from "./PassPromoDateCard";

export default function PassPromoBadge({ month, day, freeLabel }) {
  return (
    <div className="dp-promo-badge">
      <PassPromoDateCard month={month} day={day} />
      <img
        className="dp-promo-badge-icon dp-promo-badge-icon--lock"
        src={lockIcon}
        alt=""
        aria-hidden="true"
      />
      <span className="dp-promo-pill dp-promo-badge-free">{freeLabel}</span>
    </div>
  );
}
